import { FC, useState } from "react";
import { RequestExplorationTitle, SubmitRequest } from "../../../../constants";
import RenderInput from "../../RenderInput";

const Exploration: FC<{ type?: string }> = ({ type }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (key: string, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.message) {
      alert("Please fill in all fields.");
      return;
    }
    const msg = `Hello, my name is ${form.name}. My email is ${form.email}, phone: ${form.phone}. Message: ${form.message}`;
    const url = `https://wa.me/601162914913?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    // Optionally reset form here: setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="detail-sidebar-box">
      {type === "car" ? (
        <h3 className="car-title">{RequestExplorationTitle}</h3>
      ) : (
        <h4 className="detail-page-title">{RequestExplorationTitle}</h4>
      )}
      <form onSubmit={handleSubmit}>
        <RenderInput
          placeholder="Your Name"
          mainClass="detail-input"
          review
          value={form.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("name", e.target.value)}
        />
        <RenderInput
          placeholder="Email Address"
          mainClass="detail-input"
          inputType="email"
          review
          value={form.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("email", e.target.value)}
        />
        <RenderInput
          placeholder="Phone Number"
          mainClass="detail-input"
          review
          value={form.phone}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("phone", e.target.value)}
        />
        <RenderInput
          placeholder="Message"
          mainClass="detail-input"
          inputType="textarea"
          review
          value={form.message}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("message", e.target.value)}
        />
        <button type="submit" className="btn-solid mt-2" style={{ width: "100%" }}>
          {SubmitRequest}
        </button>
      </form>
    </div>
  );
};

export default Exploration;